import { AxiosError } from 'axios';

export const getErrorDetail = (error: AxiosError<Record<string, string>> | null) => {
  const errorData = error && error.response?.data;
  return errorData && errorData.detail;
};
